
define('known/models/leaguePositionModel',[
	'jquery',
	'underscore',
	'backbone',
	
	//Shims
	'backbone.relational'
], function($, _, Backbone){
	var LeaguePosition = Backbone.RelationalModel.extend({
		defaults: {
			id: null,
			name: null,
			color: null,
			//leagueInstanceId: null,
			min: null,
			max: null,
			starters: null,
			positions: null  //array
	    },
	    
	    urlRoot: function() {
	    	var lgId = this.lgId ? this.lgId : this.get("leagueInstanceId").get("leagueId");
	    	var lgInstId = this.lgInstId ? this.lgInstId : this.get("leagueInstanceId").get("id");
	    	
	    	return '/draftapp/leagues/' 
	    			+ lgId 
	    			+ '/league-instances/' 
	    			+ lgInstId 
	    			+ '/positions/';
		},
	
		initialize: function(models, options) {
			if(options.lgInstId && options.lgId){
				this.lgInstId = options.lgInstId;
				this.lgId = options.lgId;
			}
			
			if(options.prodLgName){
				this.prodLgName = options.prodLgName;
			}
	    },
	    
	    getRankingType: function() {
	    	var type = null;
	    	
	    	var prodLgName = this.prodLgName ? this.prodLgName : this.get("leagueInstanceId").get("prodLeagueName");
	    	
	    	if(prodLgName == 'NFL'){
	    		switch (this.get('name')) {
				case 'QB':
					type = 'QBRANK';
					break;
				case 'RB':
					type = 'RBRANK';
					break;
				case 'WR':
					type = 'WRRANK';
					break;
				case 'TE':
					type = 'TERANK';
					break;
				case 'K':
					type = 'KRANK';
					break;
				case 'DEF':
					type = 'DEFRANK';
					break;
				case 'IDP':
				case 'DL':
				case 'LB':
				case 'DB':
					type = 'IDPRANK';
					break;
				default:
					break;
				}
	    	} else if(prodLgName == 'MLB'){
	    		switch (this.get('name')) {
				case 'C':
					type = 'CRANK';
					break;
				case '1B':
					type = '1BRANK';
					break;
				case '2B':
					type = '2BRANK';
					break;
				case 'SS':
					type = 'SSRANK';
					break;
				case '3B':
					type = '3BRANK';
					break;
				case 'OF':
					type = 'OFRANK';
					break;
				case 'UTIL':
					type = 'HITRANK';
					break;
				case 'MI':
					type = 'HITRANK';
					break;
				case 'CI':
					type = 'HITRANK';
					break;
				case 'P':
					type = 'PITCHRANK';
					break;
				case 'SP':
					type = 'SPRANK';
					break;
				case 'RP':
					type = 'RPRANK';
					break;
				case 'CF':
					type = 'OFRANK';
					break;
				case 'LF':
					type = 'OFRANK';
					break;
				case 'RF':
					type = 'OFRANK';
					break;
				case 'DH':
					type = 'DHRANK';
					break;
				default:
					break;
				}
	    	} else if(prodLgName == 'NBA'){
	    		switch (this.get('name')) {
				case 'PG':
					type = 'PGRANK';
					break;
				case 'SG':
					type = 'SGRANK';
					break;
				case 'SF':
					type = 'SFRANK';
					break;
				case 'PF':
					type = 'PFRANK';
					break;
				case 'C':
					type = 'CRANK';
					break;
				case 'G':
					type = 'GRANK';
					break;
				case 'F':
					type = 'FRANK';
					break;
				default:
					break;
				}	    		
	    	} else if(prodLgName == 'NHL'){
	    		switch (this.get('name')) {
				case 'C':
					type = 'CRANK';
					break;
				case 'LW':
					type = 'LWRANK';
					break;
				case 'RW':
					type = 'RWRANK';
					break;
				case 'D':
					type = 'DRANK';
					break;
				case 'G':
					type = 'GRANK';
					break;
				case 'F':
					type = 'OVRRANK';
					break;	
				default:
					break;
				}
	    	}
	    	
	    	return type;
	    },
	    
	    getProjectionCategories: function() {
	    	var stats = [];
	    	var posArr = this.get('positions');
	    	for(var i=0; i<posArr.length; i++){
	    		var tmp = _.union(stats, this.getProjectionArray(posArr[i]));
	    		stats = tmp;
	    	}
	    	
	    	return stats;
	    },
	    
	    getProjectionArray: function(pos) {
	    	var stats = [];
	    	
	    	var prodLgName = this.prodLgName ? this.prodLgName : this.get("leagueInstanceId").get("prodLeagueName");
	    	
	    	if(prodLgName == 'NFL'){
		    	switch (pos) {
				case 'QB':
					stats.push('PASS_ATT');
					stats.push('PASS_COMP');
					stats.push('PASS_YDS');
					stats.push('PASS_TDS');
					stats.push('PASS_INTS');
					stats.push('RUSH_ATT');
					stats.push('RUSH_YDS');
					stats.push('RUSH_TDS');
					stats.push('FUMBLE');				
					break;
				case 'RB':
					stats.push('RUSH_ATT');
					stats.push('RUSH_YDS');
					stats.push('RUSH_TDS');
					stats.push('REC');
					stats.push('REC_YDS');
					stats.push('REC_TDS');
					stats.push('FUMBLE');
					break;
				case 'WR':
				case 'TE':
					stats.push('REC');
					stats.push('REC_YDS');
					stats.push('REC_TDS');
					stats.push('RUSH_ATT');
					stats.push('RUSH_YDS');
					stats.push('RUSH_TDS');
					stats.push('FUMBLE');
					stats.push('REC');
					stats.push('REC_YDS');
					stats.push('REC_TDS');
					stats.push('RUSH_ATT');
					stats.push('RUSH_YDS');
					stats.push('RUSH_TDS');
					stats.push('FUMBLE');
					break;
				case 'PK':
					stats.push('K_FGM');
					stats.push('K_FGA');
					stats.push('K_XP');
					stats.push('K_MISS');
					break;
				case 'DEF':
					stats.push('DEF_SACK');
					stats.push('DEF_FR');
					stats.push('DEF_INT');
					stats.push('DEF_TD');
					stats.push('DEF_SFTY');
					stats.push('DEF_PA');
					stats.push('DEF_YA');
					break;
				case 'IDP':
				case 'DL':
				case 'LB':
				case 'DB':
					stats.push('IDP_TK');
					stats.push('IDP_ASSIST');
					stats.push('IDP_SACK');
					stats.push('IDP_PADEF');
					stats.push('IDP_INT');
					stats.push('IDP_FF');
					stats.push('IDP_FR');
					break;
				case 'P':
					stats.push('PUNTS');
					stats.push('PUNT_YDS');
					stats.push('PUNT_RETYD');
					stats.push('PUNT_INS20');
					break;
				case 'HC':
					stats.push('TM_WINS');
					stats.push('TM_LOSSES');
					break;
				default:				
					stats.push('RUSH_ATT');
					stats.push('RUSH_YDS');
					stats.push('RUSH_TDS');
					stats.push('REC');
					stats.push('REC_YDS');
					stats.push('REC_TDS');
					stats.push('PASS_ATT');
					stats.push('PASS_COMP');
					stats.push('PASS_YDS');
					stats.push('PASS_TDS');
					stats.push('PASS_INTS');
					stats.push('FUMBLE');
					break;
				}
	    	}
	    	
	    	return stats;
	    }
	});
	
	return LeaguePosition;  
});